// 定义自定义错误类型
class ColorError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'ColorError';
	}
}

export {ColorError};
